<div style="width: 300px;">
    <clr-toggle-container>
        <label>Filter table values that match these values:</label>
    </clr-toggle-container>

  <button class="label label-blue" style="cursor: pointer;" (click)="checkAll()">check all</button>
  <button class="label label-blue" style="cursor: pointer;" (click)="uncheckAll()">uncheck all</button>

  <div style="max-height: 500px; overflow: scroll;">
    <clr-tree>
      @for(category_entry of categories; track category_entry[0]) {
        <clr-tree-node [(clrSelected)]="filteredValues[category_entry[0]]" [clrExpanded]="true" (change)="resourceSelectionChanged($event)">
        {{ category_entry[0] }}
        @for(tag_entry of category_entry[1]; track tag_entry[0]) {
          <clr-tree-node [(clrSelected)]="filteredValues[category_entry[0]+'->'+tag_entry[0]]" [clrExpanded]="true" (change)="resourceSelectionChanged($event)">
          {{ tag_entry[0] }}
          </clr-tree-node>
        }
        </clr-tree-node>
      }
    </clr-tree>
  </div>
</div>
